var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecovery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "rocket_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28714",
    "data-name": "Group 28714"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13848",
    "data-name": "Rectangle 13848",
    width: 16,
    height: 16,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_28715",
    "data-name": "Group 28715",
    transform: "translate(2.661 1.663)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34154",
    "data-name": "Path 34154",
    d: "M9.322,2.5s2.994,1.357,2.994,6.985a14.586,14.586,0,0,1-1.064,4.657H7.393A14.586,14.586,0,0,1,6.328,9.485C6.328,3.857,9.322,2.5,9.322,2.5Zm1.33,5.655a1.33,1.33,0,1,0-1.33,1.33A1.334,1.334,0,0,0,10.652,8.155Zm-4.2,6.333a16.342,16.342,0,0,1-1.111-4.57l-.752.5A1.338,1.338,0,0,0,4,11.527v3.945Zm8.189.985V11.527a1.318,1.318,0,0,0-.592-1.1l-.752-.5a16.644,16.644,0,0,1-1.111,4.57Z",
    transform: "translate(-4 -2.5)",
    fill: "#55555a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecovery);
export default __webpack_public_path__ + "static/media/Recovery.d7539d7fff709466d52621b4fc5719ae.svg";
export { ForwardRef as ReactComponent };